module.exports = __webpack_public_path__ + "static/risk-b230f024c1bbc7f0de86c9774c05700b.png";